


export var config = {

	utcoffset: "+0100",
	testLocations: ['localhost','test'],
	startTime: Date.now(),
	intervalUpdateTimeLogicS: 10,
	intervalReloadContentsMin: 30,
	limitedCountryCodes: ["CN","IR","KP","CU","ID","SY","SD"],
	faRulerSymbol: 'fa fa-wifi',


	passwordHash: "776fb2a42dd097997ecf84180de12675",
	passwordCookieExpirationDays: 30,

	currentScheduleItemLinksTo: "#about",

	gotoStartButtonTime: "09.03.2022, 9:00:00",
}
